import { useStores } from "../../../stores/useStores";
import { withLocaleInURI } from "../../../internationalization/i18nURI";

export function useDirectoryUrl(): string | object | undefined {
  const { organizationStore, i18nStore } = useStores();

  let directoryUrl: string | undefined | object;
  if (organizationStore.currentOrganization.type === "collection") {
    directoryUrl = organizationStore.currentOrganization.url;
  } else if (
    organizationStore.currentOrganization.id ===
      organizationStore.organization.id &&
    ["district", "organization"].includes(organizationStore.organization.type)
  ) {
    directoryUrl = {
      pathname: withLocaleInURI(
        "/directory",
        i18nStore.currentAppSupportedLocale,
      ),
    };
  }

  return directoryUrl;
}
